import PropTypes from 'prop-types';
import ExtraPropTypes from 'react-extra-prop-types';
import Endpoint from './Endpoint';

export default PropTypes.shape({
  uuid: ExtraPropTypes.uuid.isRequired,
  user: PropTypes.string, // This field may be missing when both 'MyApp' and 'App' could be used.
  // lang: PropTypes.string.isRequired, // no need to tell to the client: server uses it internally

  image: ExtraPropTypes.uuid,

  completed: PropTypes.bool,
  approval: ExtraPropTypes.integer,
  published: PropTypes.bool,

  tag1: PropTypes.string,
  tag2: PropTypes.string,
  tag3: PropTypes.string,
  tag4: PropTypes.string,
  tag5: PropTypes.string,

  guideName: PropTypes.string,
  guideDesc: PropTypes.string,
  guideImage: PropTypes.string,
  guideRating: PropTypes.number,
  guideReviews: ExtraPropTypes.integer,

  name: PropTypes.string, // This field may be missing when both 'MyApp' and 'App' could be used.
  desc: PropTypes.string, // This field may be missing when both 'MyApp' and 'App' could be used.

  duration: ExtraPropTypes.integer, // .isRequired,

  type: ExtraPropTypes.integer,
  rentPrice: PropTypes.number,
  rentDays: ExtraPropTypes.integer,
  buyPrice: PropTypes.number,
  promoted: PropTypes.bool,

  endpoints: PropTypes.arrayOf(Endpoint),
  endpointIds: PropTypes.string,
});
